var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "170px",
    viewBox: "0 0 105 170",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7AF01CB8-0B61-433A-BB76-9A3AB731D4F5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-sign-up-(1)",
    transform: "translate(-143.000000, -337.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(143.000000, 337.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,32.5 L85,32.5 C113.994949,32.5 137.5,56.0050506 137.5,85 C137.5,113.994949 113.994949,137.5 85,137.5 L20,137.5 C-8.99494937,137.5 -32.5,113.994949 -32.5,85 C-32.5,56.0050506 -8.99494937,32.5 20,32.5 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(52.500000, 85.000000) scale(1, -1) rotate(-90.000000) translate(-52.500000, -85.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,118 C34.5507456,118 20,103.449254 20,85.5 C20,67.5507456 34.5507456,53 52.5,53 C70.4492544,53 85,67.5507456 85,85.5 C85,103.449254 70.4492544,118 52.5,118 L52.5,118 Z M52.5,57.6428571 C37.1149248,57.6428571 24.6428571,70.1149248 24.6428571,85.5 C24.6428571,100.885075 37.1149248,113.357143 52.5,113.357143 C67.8850752,113.357143 80.3571429,100.885075 80.3571429,85.5 C80.3571429,70.1149248 67.8850752,57.6428571 52.5,57.6428571 Z",
    id: "Shape",
    fill: "#C4CF15",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(52.500000, 86.207107) rotate(135.000000) translate(-52.500000, -86.207107) translate(38.843146, 72.550253)",
    fill: "#C4CF15",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0179919,27.3137085 C24.4113014,27.3171808 23.828177,27.0788066 23.3974297,26.6512041 L11.9850196,15.2293736 C11.4060484,14.6499245 11.1799345,13.8053592 11.3918526,13.013817 C11.6037707,12.2222749 12.2215256,11.6040102 13.0124148,11.3919171 C13.8033041,11.179824 14.6471729,11.4061247 15.226144,11.9855737 L26.6385541,23.4074042 C27.0706569,23.8363319 27.3137085,24.4202064 27.3137085,25.0293042 C27.3137085,25.6384019 27.0706569,26.2222764 26.6385541,26.6512041 C26.2078068,27.0788066 25.6246824,27.3171808 25.0179919,27.3137085 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.29572409,27.3137085 C1.68903158,27.3171808 1.10590531,27.0788059 0.675156563,26.6512019 C0.243052429,26.2222729 0,25.6383964 0,25.0292967 C0,24.420197 0.243052429,23.8363205 0.675156563,23.4073915 L12.087604,11.9855236 C12.9826187,11.0897701 14.4337242,11.0897701 15.328739,11.9855236 C16.2237537,12.8812771 16.2237537,14.3335805 15.328739,15.2293341 L3.91629162,26.6512019 C3.48554288,27.0788059 2.90241661,27.3171808 2.29572409,27.3137085 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6094251,16 C13.0027346,16.0034723 12.4196102,15.7650981 11.9888629,15.3374956 C11.5567601,14.9085679 11.3137085,14.3246934 11.3137085,13.7155957 C11.3137085,13.1064979 11.5567601,12.5226234 11.9888629,12.0936957 L23.401273,0.671865193 C23.9802441,0.0924161557 24.8241129,-0.133884454 25.6150022,0.0782086141 C26.4058914,0.290301682 27.0236463,0.908566445 27.2355644,1.70010855 C27.4474825,2.49165065 27.2213686,3.33621603 26.6423974,3.91566506 L15.2299873,15.3374956 C14.79924,15.7650981 14.2161156,16.0034723 13.6094251,16 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7042759,16 C13.0975834,16.0034723 12.5144571,15.7650974 12.0837084,15.3374934 L0.671260986,3.91562556 C-0.223753687,3.01987202 -0.223753658,1.56756865 0.67126105,0.671815146 C1.56627576,-0.223938357 3.0173813,-0.223938386 3.91239604,0.671815083 L15.3248434,12.093683 C15.7569476,12.522612 16,13.1064885 16,13.7155882 C16,14.3246879 15.7569476,14.9085644 15.3248434,15.3374934 C14.8940947,15.7650974 14.3109684,16.0034723 13.7042759,16 L13.7042759,16 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBig);
export default __webpack_public_path__ + "static/media/plus-big.b9a978a2a07c222e9a92e27aa0f26402.svg";
export { ForwardRef as ReactComponent };